var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 319.243 256.331 L 255.985 277.505 319.497 298.670 L 383.009 319.834 444.754 299.280 C 513.963 276.240, 508.254 278.439, 505.237 275.993 C 502.949 274.138, 386.776 234.933, 384 235.079 C 383.175 235.122, 354.034 244.686, 319.243 256.331 M 318.494 491.578 C 352.040 502.810, 379.940 511.965, 380.494 511.922 C 381.047 511.878, 354.053 502.653, 320.506 491.422 C 286.960 480.190, 259.060 471.035, 258.506 471.078 C 257.953 471.122, 284.947 480.347, 318.494 491.578",
    stroke: "none",
    fill: "#8bb9ff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 193.596 19.548 C 117.987 44.870, 128 26.144, 128 142.224 L 128 234.512 190.750 255.402 C 225.262 266.891, 254.063 276.499, 254.750 276.753 C 255.745 277.120, 256 257.521, 256 180.852 L 256 84.490 317.913 63.858 C 365.546 47.985, 380.133 43.489, 381.155 44.363 C 381.886 44.988, 381.180 44.051, 379.585 42.281 C 351.419 11.013, 254.467 -0.837, 193.596 19.548 M 383.480 142 C 383.480 193.425, 383.601 214.462, 383.750 188.750 C 383.898 163.037, 383.898 120.962, 383.750 95.250 C 383.601 69.537, 383.480 90.575, 383.480 142",
    stroke: "none",
    fill: "#ffb454",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 317.750 63.846 L 256 84.488 256 180.851 C 256 257.520, 256.255 277.120, 257.250 276.754 C 257.938 276.501, 286.512 266.966, 320.750 255.564 L 383 234.833 383 141.027 C 383 25.658, 393.795 38.426, 317.750 63.846",
    stroke: "none",
    fill: "#ff8e00",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.245 374.013 L 256.500 470.026 319.500 491.010 C 394.642 516.040, 376.353 515.724, 444.010 493.159 C 505.538 472.639, 506.184 472.386, 509.040 467.701 C 511.699 463.341, 512.148 286.121, 509.514 281.026 C 508.027 278.152, 508.027 278.152, 445.514 298.995 L 383 319.839 320.259 298.920 C 285.751 287.414, 257.174 278, 256.754 278 C 256.334 278, 256.105 321.206, 256.245 374.013",
    stroke: "none",
    fill: "#2478ec",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 67.645 254.532 C 6.912 274.871, 6.062 275.210, 2.956 280.304 C -0.096 285.310, -0.093 462.696, 2.960 467.701 C 5.999 472.686, 117.404 512, 128.490 512 C 131.040 512, 154.983 504.506, 194.250 491.417 L 256 470.833 256 374.057 L 256 277.281 192.750 256.129 C 157.962 244.495, 128.600 235.017, 127.500 235.066 C 126.400 235.116, 99.465 243.876, 67.645 254.532",
    stroke: "none",
    fill: "#ea5f2e",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.ac85f2eb5486ac56fd727135ced969a8.svg";
export { ForwardRef as ReactComponent };